import axios from "axios";

export const GetComercioContactos = async (idComercio: number) => {
    return axios.get(`api/comercio/ConsultarComercioContactos/?idComercio=${idComercio}`)
}

export const deleteComercioContacto = async (idComercio: number, idContacto: number) => {
    //return axios.delete(`api/comercio/EliminarComercioContactos/?idComercio=${idComercio}&idContacto=${idContacto}`)
    return axios.post(`api/comercio/EliminarComercioContactos/?idComercio=${idComercio}&idContacto=${idContacto}`)
}

export const modificarContactoComercio = async (idComercio: number, idContacto: number, request: any) => {
    //return axios.put(`api/comercio/ActualizarComercioContactos/?idComercio=${idComercio}&idContacto=${idContacto}`, request)
    return axios.post(`api/comercio/ActualizarComercioContactos/?idComercio=${idComercio}&idContacto=${idContacto}`, request)
}

export const crearContactoComercio = async (idComercio: number, request: any) => {
    return axios.post(`api/comercio/CrearComercioContacto/?idComercio=${idComercio}`, request)
}

export const consultarTipoContactoComercio = async () => {
    return axios.get('api/comercio/ConsultarTipoContactoComercio')
}

/*
import {
    SUCCESS_POST_CONTACTOCOMERCIO, FAILED_POST_CONTACTOCOMERCIO, ERROR_POST_CONTACTOCOMERCIO,
} from "../utilities/constants";
import { IComercioContactoRequest } from "../../../interfaces/IComercioContactoRequest";

export const PostComercioContacto = async (idComercio: number, contactoComercio: IComercioContactoRequest) => {
    try {
        const response = await fetch(`api/comercio/CrearComercioContacto/${idComercio}`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(contactoComercio)
        })
        if (response.status === 200) {
            let result = await response.json();
            return { data: result, message: SUCCESS_POST_CONTACTOCOMERCIO };
        } else {
            return { data: [], message: FAILED_POST_CONTACTOCOMERCIO };
        }

    } catch (error) {
        return { data: [], message: ERROR_POST_CONTACTOCOMERCIO, error: error };
    }
}*/